import Hammer from 'hammerjs';

const countries = {
	1: 'Испания',
	2: 'Италия',
	3: 'Грузия',
	4: 'Нидерланды',
	5: 'Австрия',
	6: 'Япония',
	7: 'Индия',
	8: 'Тайланд',
	9: 'Турция',
	10: 'Германия',
	11: 'Россия',
	12: 'Мексика',
	13: 'Великобритания',
	14: 'Аргентина'
};

const months = {
	1: 'Январь',
	2: 'Февраль',
	3: 'Март',
	4: 'Апрель',
	5: 'Май',
	6: 'Июнь',
	7: 'Июль',
	8: 'Август',
	9: 'Сентябрь',
	10: 'Октябрь',
	11: 'Ноябрь',
	12: 'Декабрь'
};

const CURRENT_MONTH = 10;
const DOMAIN = 'http://25events.woman.ru/';
const hammertime = new Hammer(document.querySelector('.s'));
hammertime.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });

export default class Page {
	constructor(data) {
		this.data = [];
		this.active = false;
		this.activeIndex = 0;
		this.timeout = 500;
		this.dom = {
			content: {
				place: $('.content__place'),
				name: $('.content__name'),
				date: $('.content__date'),
				text: $('.content__text'),
				list: $('.content__list')
			},
			controls: {
				prev: $('.s__control.prev'),
				next: $('.s__control.next'),
				goBtn: $('.m__btn'),
				goText: $('.m__go')
			},
			nav: {
				container: $('.nav'),
				btn: $('.nav__btn'),
				list: $('.nav__list'),
				overlay: $('.nav__overlay')
			},
			overlay: $('.overlay'),
			slides: $('.slides'),
			images: $('.js-slick-slider'),
			timeline: $('.timeline__list'),
			timelineItem: $('.timeline__item'),
			bg: $('.s__bg')
		};

		this.interval = null;
		this.timelineIndex = 0;

		this.bindEvents();
		this.prepareData(data);
		this.detectHash();
		this.renderTimeline();
		this.renderNav();
	}

	prepareData(data) {
		const arr = [];
		for (let key in data) {
			arr.push(data[key]);
		}
		arr.map((item) => {
			item.month = months[item.begin];
			item.country = countries[item.country];
		});
		this.data = arr;
	}

	bindEvents() {
		this.dom.controls.goBtn.on('click', this.onGoClickHandler);
		this.dom.controls.goText.on('click', this.onGoClickHandler);
		this.dom.controls.prev.on('click', this.onPrevClickHandler);
		this.dom.controls.next.on('click', this.onNextClickHandler);
		this.dom.nav.btn.on('click', this.onNavBtnClickHandler);
		this.dom.nav.overlay.on('click', this.onNavOverlayClickHandler);
		this.dom.nav.container.on('click', '.nav__item', this.onNavItemClickHandler);
		this.dom.timeline.on('click', '.timeline__item', this.onTimelineItemClickHandler);
		this.dom.timeline.on('mouseover', '.timeline__item', this.onTimelineItemMouseOverHandler);
		this.dom.timeline.on('mouseout', '.timeline__item', this.onTimelineItemMouseOutHandler);
		$('.m').bind('mousewheel DOMMouseScroll', this.onScrollHandler);
		$('.timeline__next').on('mouseover', this.onTimelineNextMouseOverHandler);
		$('.timeline__prev').on('mouseover', this.onTimelinePrevMouseOverHandler);
		$('.timeline__next, .timeline__prev').on('mouseout', this.onTimelineouseOutHandler);
		hammertime.on('swipe', this.onSwipeHandler);
		$(window).on('hashchange', this.onHashChangeHandler);
	}

	detectHash() {
		const id = Number(window.location.hash.replace('#', ''));
		if (id > 0 && id <= this.data.length) {
			this.active = true;
			this.onSwitchSlides(id - 1);
		}else if (id > this.data.length) {
			window.location.hash = this.data.length;
		}else if (id <= 0) {
			this.active = false;
			removeHash();
		}

	}

	onHashChangeHandler = (e) => {
		const id = Number(window.location.hash.replace('#', ''));
		if (id > 0 && id <= this.data.length) {
			this.active = true;
			this.onSwitchSlides(id - 1);
		}else if (id > this.data.length) {
			window.location.hash = this.data.length;
		}else if (id <= 0) {
			this.active = false;
			removeHash();
		}
	}

	onSwipeHandler = (e) => {
		if (e.deltaX < 0) {
			this.onNextClickHandler();
		}else if (e.deltaX > 0) {
			this.onPrevClickHandler();
		}
	}

	onTimelineouseOutHandler = () => {
		clearInterval(this.interval);
	}

	onTimelinePrevMouseOverHandler = () => {
		const timelineWidth = this.dom.timeline.children().eq(0).width();
		this.interval = setInterval(() => {
			this.timelineIndex -= 1;
			if (this.timelineIndex < 0) {
				clearInterval(this.interval);
			}
			this.dom.timeline.css({
				transform: `translateX(-${timelineWidth / 1.5 * (this.timelineIndex)}px)`
			});
		}, 500);

	}

	onTimelineNextMouseOverHandler = () => {
		const timelineWidth = this.dom.timeline.children().eq(0).width();
		this.interval = setInterval(() => {
			this.timelineIndex += 1;
			if (this.timelineIndex >= this.data.length - 1) {
				clearInterval(this.interval);
			}
			this.dom.timeline.css({
				transform: `translateX(-${timelineWidth / 1.5 * (this.timelineIndex)}px)`
			});
		}, 500);
	}

	onTimelineItemMouseOutHandler = (e) => {
		this.updateTimelineState(this.activeIndex, false);
	}

	onTimelineItemMouseOverHandler = (e) => {
		const id = $(e.target).closest('.timeline__item').index();
		this.updateTimelineState(id, false);
	}

	onTimelineItemClickHandler = (e) => {
		const id = $(e.target).closest('.timeline__item').index();

		if (id !== this.activeIndex) {
			this.onSwitchSlides(id);
		}
	}

	onScrollHandler = (e) => {
		if (!this.active) {
			if (e.originalEvent.wheelDelta <= 0 || e.originalEvent.detail >= 0) {
				this.active = true;
				this.dom.controls.goBtn.addClass('active').delay(this.timeout * 2).queue(function () {
					$(this).removeClass('active').dequeue();
				});
				setTimeout(() => {
					this.onSwitchSlides(0);
				}, this.timeout);
			}
		}
	}

	onNavItemClickHandler = (e) => {
		const id = $(e.target).parent().index();
		if (this.active === false || id !== this.activeIndex) {
			window.location.hash = id + 1;
			this.active = true;
			// this.onSwitchSlides(id);
		}
		this.dom.nav.container.removeClass('active');
	}

	onNavOverlayClickHandler = () => {
		this.dom.nav.container.removeClass('active');
	}

	onNavBtnClickHandler = () => {
		this.dom.nav.container.addClass('active');
	}

	onPrevClickHandler = () => {
		const id = this.activeIndex - 1;
		window.location.hash = id + 1;
		if (id < 0) {
			this.active = false;
			this.onSwitchSlides(id);
			removeHash();
		}
		// this.onSwitchSlides(id);
	}

	onNextClickHandler = () => {
		const id = this.activeIndex + 1;
		if (id < this.data.length) {
			window.location.hash = id + 1;
			// this.onSwitchSlides(id);
		}
	}

	onGoClickHandler = () => {
		this.active = true;
		this.dom.controls.goBtn.addClass('active').delay(this.timeout * 2).queue(function () {
			$(this).removeClass('active').dequeue();
		});
		setTimeout(() => {
			window.location.hash = 1;
		}, this.timeout);
	}

	overlayToPrev() {
		this.dom.overlay.removeClass('next prev').delay(this.timeout).queue(function () {
			$(this).addClass('next').dequeue();
		});
	}

	overlayToNext() {
		this.dom.overlay.removeClass('next prev').delay(this.timeout).queue(function () {
			$(this).addClass('prev').dequeue();
		});
	}

	onSwitchSlides(id) {
		let dir = '';

		if (id >= this.activeIndex) {
			dir = 'next';
		} else {
			dir = 'prev';
		}

		this.activeIndex = id;

		if (this.active) {
			setTimeout(() => {
				this.setData();
			}, this.timeout / 2);
		}

		const i = id + 1;
		ga('send', 'pageview', '/#section' + i);
		ga('send', 'event', 'Scroll to ' + i, i + ' screen', 'scroll', 0, {nonInteraction: true});

		switch (dir) {
			case 'prev':
				// this.overlayToNext();
				if (!this.active) {
					setTimeout(() => {
						$('body').removeClass('active');
					}, this.timeout);
				}
				break;
			case 'next':
				// this.overlayToPrev();
				if (this.active) {
					setTimeout(() => {
						$('body').addClass('active');
					}, this.timeout);
				}
				break;
		}
	}

	renderTimeline() {
		let prevMonth = '';
		const markup = this.data.map((item) => {
			let isMonthShowed = false;
			if (item.month !== prevMonth) {
				isMonthShowed = true;
				prevMonth = item.month;
			}
			return `
				<li class="timeline__item">
					<p class="timeline__name">${item.country}</p>
					<div class="timeline__dot"></div>
					<p class="timeline__month">${isMonthShowed ? item.month : ''}</p>
				</li>
			`;
		});
		this.dom.timeline.html(markup);
	}

	renderNav() {
		const markup = this.data.map((item) => {
			return `
				<li class="nav__item">
					<p class="nav__place">${item.city} (${item.country})</p>
					<p class="nav__name">${item.title}</p>
				</li>
			`;
		});
		this.dom.nav.list.html(markup);
	}

	renderSlider() {
		$('.slider__slide.active').fadeOut(1000).removeClass('active');
		$('.slider__slide').eq(this.activeIndex).fadeIn(1000).addClass('active');
		$('.slider-m__slide.active').fadeOut(1000).removeClass('active');
		$('.slider-m__slide').eq(this.activeIndex).fadeIn(1000).addClass('active');
	}

	renderContentInfo({ city, country, title, desc, period }) {
		this.dom.content.place.html(`${city} (${country})`);
		this.dom.content.name.html(title);
		this.dom.content.text.html(desc);
		this.dom.content.date.html(period);
	}

	renderContentIcons(takes) {
		const takesArr = [];
		for (let key in takes) {
			takesArr.push(takes[key]);
		}
		const markup = takesArr.map((item) => {
			const desc = item.desc.replace(/не пропустить событие из-за боли/g, '<a href="http://pubads.g.doubleclick.net/gampad/clk?id=4832104774&iu=/81006599/hmiru-woman/clk-counter" target="_blank" rel="noopener">не пропустить событие из-за боли</a>');
			return `
				<li class="content__item">
					<img src="${DOMAIN}${item.svg}" class="content__icon" />
					<div class="content__info">
						<p class="content__infoTitle">${item.name}</p>
						<p class="content__infoText">${desc}</p>
					</div>
				</li>
			`;
		});

		this.dom.content.list.html(markup);
	}

	updateTimelineState(id, move = true) {
		let timelineWidth = 0;

		this.dom.timeline.children().each((i, item) => {
			$(item).removeClass('prev active');

			if (!timelineWidth || timelineWidth > $(item).width()) {
				timelineWidth = $(item).width();
			}

			if (i === id) {
				$(item).addClass('active');
			}

			if (i === id - 1) {
				$(item).addClass('prev');
			}
		});

		if (move) {
			this.dom.timeline.css({
				transform: `translateX(-${timelineWidth / 1.5 * (id)}px)`
			});
		}
	}

	updateSlideBackground() {
		$('.s__bg.active').fadeOut(1000).removeClass('active');
		$('.s__bg').eq(this.activeIndex).fadeIn(1000).addClass('active');
	}

	isNextButtonHide() {
		if (this.activeIndex >= this.data.length - 1) {
			this.dom.controls.next.hide();
		} else {
			this.dom.controls.next.show();
		}
	}

	setData() {
		const currentData = this.data[this.activeIndex];
		const takes = currentData.take_with_you;

		this.isNextButtonHide();
		this.updateTimelineState(this.activeIndex);
		this.updateSlideBackground();
		this.renderSlider();
		this.renderContentInfo(currentData);
		this.renderContentIcons(takes);
	}
}

function removeHash() {
	history.pushState('', document.title, window.location.pathname + window.location.search);
}



// WEBPACK FOOTER //
// ./app/scripts/page.js